import TermDrawer from "../TermDrawer";
import "./TagsDrawer.scss";

const EditTagsDrawer = () => <TermDrawer type="edit-tag" />;

export default EditTagsDrawer;
